import { helper } from '@ember/component/helper';

export interface MathAddSignature {
  Args: {
    Positional: [number, number];
  };
  Return: number;
}

const mathAdd = helper<MathAddSignature>((params) => {
  return params[0] + params[1];
});

export default mathAdd;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'math-add': typeof mathAdd;
  }
}
